import Vue from 'vue'
import Router from 'vue-router'
import DeliveryInfo from '@/components/DeliveryInfo'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify, {
  iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
})
Vue.use(Router)

// date time util
Vue.use(require('vue-moment'))

// cookie
Vue.use(require('vue-cookie'))

// adsense
Vue.use(require('vue-script2'))

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/hello',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'Delivery',
      component: DeliveryInfo
    }
    // {
    //   path: '/test',
    //   name: 'Test',
    //   component: TestComponent
    // },
    // {
    //   path: '/list',
    //   name: 'List',
    //   component: ListTest
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js